import {Button, Form, Input, Layout, Menu, Space} from 'antd';
import './Footer.less';
import {Link, useLocation, useNavigate} from 'react-router';
import main_logo from '../../../assets/logo/mainLogo.png';
import heartSvg from '../../../assets/logo/heart.png';
import {menuData} from './footerData';
import x from '../../../assets/icons/x.png';
import linkedin from '../../../assets/icons/linkedin.png';
import facebook from '../../../assets/icons/facebook.png';
import {useEffect, useState} from 'react';
import SuccessOrErrorModal from '../../Modal/Modal';

const Footer: React.FC = () => {
	const [form] = Form.useForm();
	const [modalContent, setModalContent] = useState({title: '', content: ''});
	const [modalType, setModalType] = useState<'success' | 'error'>('success');
	const [isModalVisible, setIsModalVisible] = useState(false);

	const location = useLocation();

	useEffect(() => {
		form.resetFields();
	}, [location.pathname]);

	const navigate = useNavigate();
	const handleNavigate = (link: string | undefined) => {
		if (link) {
			window.open(link, '_blank');
		} else {
			console.log('No link available for this company');
		}
	};
	const {Content} = Layout;

	const handleSubmit = async (values: any) => {
		try {
			const response = await fetch('./send-email.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(values)
			});

			const result = await response.json();

			if (response.ok) {
				setModalType('success');
				setModalContent({
					title: 'Success',
					content:
						'Thank you for subscribing! 🎉 Your subscription has been successfully received. Stay tuned for updates and exclusive content. If you have any questions, feel free to contact us.'
				});
			} else {
				setModalType('error');
				setModalContent({
					title: 'Error',
					content: `${result}`
				});
			}

			setIsModalVisible(true);
			form.resetFields();
		} catch (error) {
			setModalType('error');
			setModalContent({
				title: 'Error during submission',
				content: `${error}`
			});
			setIsModalVisible(true);
		}
	};
	return (
		<main className="footer_main">
			<Content className="footer_content">
				<div className="footer_info_content">
					<div className="footer_info_block">
						<div className="logo_block">
							<Link to={'/'} className="main_logo">
								<img src={main_logo} alt="company_logo" />
							</Link>
						</div>
						<div className="footer_description_block">
							<p className="footer_description_text">
								We’re here to assist you. Whether you’re exploring a partnership, need a
								tailored solution, or have a question — our team is ready to help.
							</p>
						</div>
						<div className="footer_subscription_block">
							<Form
								form={form}
								onFinish={handleSubmit}
								layout="inline"
								requiredMark={true}
								className="custom_form_style">
								<Space.Compact>
									<Form.Item
										name="email"
										// validateTrigger="onFocus"
										validateTrigger="onBlur"
										rules={[
											{required: true, message: 'Please input your email'},
											{type: 'email', message: 'Please input valid email'}
										]}>
										<Input className="custom_input" placeholder="Your email" />
									</Form.Item>
								</Space.Compact>
								<Button className="footer_subscription_button" htmlType="submit">
									Subscribe
								</Button>
							</Form>
						</div>
					</div>
					<div className="footer_menu_items_block">
						<div className="footer_menu_items">
							{menuData.map((item: any, index: number) => (
								<div key={index} className="footer_menu_section">
									{item.children.map((child: any, childIndex: number) => (
										<Link key={childIndex} className="footer_subtitle" to={child.path}>
											<p className="footer_menu_item">{child.title}</p>
										</Link>
									))}
								</div>
							))}
						</div>
					</div>
				</div>
				<div className="footer_straight_line"></div>
				<div className="footer_bottom">
					<div className="footer_bottom_left_text">
						<p>
							© 2025 Hexagon Group. All rights reserved.{' '}
							<span onClick={() => navigate('/privacy-policy')}>Privacy & Policy</span>
						</p>
					</div>
					<div className="footer_social_media_icons_block">
						<div
							onClick={() =>
								handleNavigate('https://www.linkedin.com/company/crossgrouparmenia/')
							}
							className="footer_social_media_icons">
							<img src={linkedin} alt="linkedin logo" />
						</div>
					</div>
				</div>
				<SuccessOrErrorModal
					isVisible={isModalVisible}
					onClose={() => setIsModalVisible(false)}
					title={modalContent.title}
					content={modalContent.content}
					modalType={modalType}
				/>
			</Content>
		</main>
	);
};

export default Footer;
